import { message } from 'antd';

export const copyToClipboard = (text) => {
    if (!text) return;

    // Try Modern API
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
            message.success('复制成功');
        }).catch(err => {
            console.error('Modern copy failed:', err);
            fallbackCopy(text);
        });
    } else {
        fallbackCopy(text);
    }
};

const fallbackCopy = (text) => {
    try {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Ensure it's not visible but part of DOM
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
            message.success('复制成功');
        } else {
            message.error('复制失败');
        }
    } catch (err) {
        console.error('Fallback copy failed:', err);
        message.error('复制失败');
    }
};
